<template>
  <div>
    <b-card>
      <title-text />
      <content-text />
    </b-card>
    <file-card />
  </div>
</template>

<script>
import {
  BCard,
} from 'bootstrap-vue'
import TitleText from '@/views/Admin/Laboratory_forms/elements/TitleText.vue'
import ContentText from '@/views/Admin/Laboratory_forms/elements/ContentText.vue'
import FileCard from '@/views/Admin/Laboratory_forms/elements/FileCard.vue'

export default {
  name: 'ItemForm',
  components: {
    BCard,
    TitleText,
    ContentText,
    FileCard,
  },
  computed: {
    dataItem() {
      return this.$store.getters['laboratoryForms/dataItem']
    },
  },
}
</script>
